import IframeWrapper from "./components/IframeWrapper";

function App() {
  return <IframeWrapper />;
}

export default App;
